module.exports = __webpack_public_path__ + "img/02.8faa5f9d.jpg";